import { css } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';
import COLORS, { COLORS_LINK } from '@zola/zola-ui/src/styles/emotion/colors';
// TODO: re-factor style utils to pre-pend '#' and use style util functions

const grayDark = '#7f7f7f'; // TODO: replace with existing color
export const getRegistryPageOverride = (backgroundColor?: string | null): SerializedStyles => {
  return css`
    #registry-page {
      #registry-zola {
        ${backgroundColor && `background: ${COLORS.WHITE} !important;`}
        .registry-nav {
          color: ${COLORS.BLACK} !important;
          a,
          i {
            color: ${COLORS.BLACK} !important;
            .zolaicon-cart {
              font-size: 24px;
              margin-right: 5px;
              color: ${grayDark};
            }
          }
          .registry-weddings-header & {
            color: ${grayDark};
            a:not(.btn),
            i {
              color: ${grayDark};
            }
          }
          ${backgroundColor && `background:  ${COLORS.WHITE} !important;`}
          .zola-registry-logo-dark {
            display: inline-block;
          }
          .zola-registry-logo-light {
            display: none;
          }
        }
        textarea,
        input {
          ${backgroundColor && `background:  ${COLORS.WHITE} !important;`}
        }
        #public-registry {
          .rail-header,
          .filter-control .clear-filter,
          .sort-control > label {
            color: ${COLORS.BLACK} !important;
          }
          h2.product-count {
            color: ${COLORS.BLACK} !important;
          }
          label.control-label {
            color: ${COLORS.BLACK} !important;
          }
          .rail-tree a.tree-root {
            color: ${COLORS.BLACK} !important;
            &:hover,
            &.active {
              color: ${COLORS.LINK_HOVER} !important;
            }
          }
          .nav-rail {
            color: ${COLORS_LINK.SECONDARY} !important;
            a:hover,
            a.active {
              color: ${COLORS.LINK_HOVER} !important;
            }
          }
          .facet-options .checkbox {
            & > label {
              color: ${COLORS_LINK.SECONDARY} !important;
              &:hover {
                color: ${COLORS.LINK_HOVER} !important;
              }
              & > * {
                color: ${COLORS_LINK.SECONDARY} !important;
              }
            }
            &.active > label {
              color: ${COLORS.LINK_HOVER} !important;
            }
          }
          i.zola-ui-icon-close {
            color: ${COLORS.BLACK} !important;
          }
          button.v2-button.secondary-button {
            color: initial !important;
          }
        }
        .zola-registry-message p {
          color: ${grayDark} !important;
          font-style: italic;
          letter-spacing: 0.95px;
          border-top: solid 1px #d9d9d9;
          border-bottom: solid 1px #d9d9d9;
          line-height: 1.42857143;
        }
      }
    }
  `;
};
